// postViews.ts
// Registers a "view" for shop posts, at most once per post per browser session,
// so the portal dashboard can show post reach. Fire-and-forget: a failure never
// affects what the viewer sees.

import { supabase } from './supabase'

export async function registerPostViews(postIds: (string | null | undefined)[]) {
  try {
    const fresh: string[] = []
    for (const id of postIds) {
      if (!id) continue
      const key = `sb_pv_${id}`
      try {
        if (sessionStorage.getItem(key)) continue
        sessionStorage.setItem(key, '1')
      } catch {
        // sessionStorage unavailable (private mode) — still count the view
      }
      fresh.push(id)
    }
    if (fresh.length === 0) return
    await supabase.rpc('increment_post_views', { p_ids: fresh })
  } catch {
    // ignore — view counts are best-effort
  }
}
